<template>
<div>
  <el-table :data="lineTableData" stripe border :header-cell-style="{textAlign: 'center'}"
            :cell-style="{ textAlign: 'center', width: '100%',}" style="height: 470px">
    <el-table-column prop="index" label="序号" width="80" fixed>
      <template v-slot="scope">
        {{ scope.$index + 1 }}
      </template>
    </el-table-column>
    <el-table-column prop="wujian_id" label="物件番号" min-width="110" />
    <el-table-column prop="wujian_short_name" label="物件略称" min-width="110" />
    <el-table-column prop="lot_no" :label="$t('makeSchedule.mfgAssemblyReportDetail.batchNo')" min-width="110" />
    <el-table-column prop="unit_no" :label="$t('makeSchedule.mfgAssemblyReportDetail.unitNo')" min-width="110" />
    <el-table-column prop="storey" :label="$t('makeSchedule.mfgAssemblyReportDetail.floor')" min-width="110" />
    <el-table-column prop="area" :label="$t('makeSchedule.mfgAssemblyReportDetail.area')" min-width="110" />
  </el-table>
  <div class="pageStyle">
    <el-pagination
        style="margin-right: 13px"
        background layout="sizes, total, prev, pager, next"
        :total="total"
        :current-page="pageNum"
        @current-change="currentCheckChange"
        @size-change="sizeCheckChange"
        :page-sizes="[10,30,50,100,300]">
    </el-pagination>
  </div>

</div>
</template>

<script>
export default {
  name: "MfgAssemblyReportLine",
  props: {
    activeName: {
      type: String,
      default: () => {
        return ""
      }
    },
    productionDate: {
      type: String,
      default: () => {
        return ""
      }
    }
  },
  data(){
    return {
      fromData: {},
      lineTableData:[],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },methods: {
    currentCheckChange(page_num) {
      this.pageNum = page_num;
      this.getLineTableData();
    },
    sizeCheckChange(pageSize) {
      this.pageSize = pageSize;
      this.getLineTableData();
    },
    getLineTableData() {
      this.fromData.activeName = this.$props.activeName;
      this.fromData.production_date = this.$props.productionDate;
      this.fromData.pageNum = this.pageNum;
      this.fromData.pageSize = this.pageSize;
      this.$axios.post('mfg/lineData/getLineTableData',this.fromData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }

        this.total = res.data.total;
        this.lineTableData = res.data.records;
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    }
  },created() {
    this.getLineTableData();
  }
}
</script>

<style scoped>
.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 5px 0
}
</style>